<template>
  <div>
    <rescheck ref="checkApp" @backFun="checkApp"></rescheck>
    <selectTable ref="selApp" @backFun="selApp"></selectTable>
    <healthCard ref="cardApp" @backFun="cardApp"></healthCard>
  </div>
</template>
<script>
import rescheck from "@/components/fksys/resCheck";
import selectTable from "@/components/fksys/selectTable";
import healthCard from "@/components/fksys/healthCard";
import $ from "jquery"; //在需要使用的页面中
import { getReservationListByCondition, baseSocketUrl, ws } from "@/api/api";
export default {
  components: { rescheck, selectTable, healthCard },
  data() {
    return {
      user: JSON.parse(window.localStorage.user),
      webSocketState: 0, //0未开启，1已开启
      webSocketHandles: [], //webSocket处理集合
      timer: "",
      reservationId: ""
    };
  },
  created() {
    this.webSocket();
    this.timer = setInterval(this.authPerson, 2000); //人员认证
  },
  methods: {
    webSocket() {
      var _this = this;
      if (typeof WebSocket == "undefined") {
        this.$notify({
          title: "提示",
          message: "当前浏览器无法接收实时报警信息，请使用谷歌浏览器！",
          type: "warning",
          duration: 0
        });
      } else {
        // 实例化socket，这里我把用户名传给了后台，使后台能判断要把消息发给哪个用户，其实也可以后台直接获取用户IP来判断并推送
        //参数socketUrl：岗亭二维码
        //公司id_门卫id
        var par = this.user.companyId + "_" + this.user.door.id;
        const socketUrl = baseSocketUrl + par;
        var socket = new WebSocket(socketUrl);
        // 监听socket打开
        socket.onopen = function() {
          _this.webSocketState = 1;
        };
        // 监听socket消息接收
        socket.onmessage = function(msg) {
          let tempdata = JSON.parse(event.data);
          switch (tempdata.Code) {
            case "1":
              //把处理对象添加到集合中
              var para = {
                params: {
                  pageIndex: 1,
                  pageSize: 1,
                  id: tempdata.Id,
                  targetCompanyId: _this.user.companyId
                }
              };
              getReservationListByCondition(para).then(res => {
                var row = res.data.data.list[0];
                if (row.targetCompanyName != undefined) {
                  var msg =
                    "<div><span>企业：</span>" +
                    row.targetCompanyName +
                    "</div>" +
                    "<div><span>人员：</span>" +
                    row.visitorUserName +
                    "</div>";
                  _this.$notify({
                    title: "预约审核",
                    dangerouslyUseHTMLString: true,
                    message: msg,
                    duration: 0,
                    position: "bottom-right",
                    onClose() {
                      _this.$refs.checkApp.oper(row);
                    }
                  });
                }
              });
              break;
            case "2":
              break;
            case "3":
              break;
          }
        };
        // 监听socket错误
        socket.onerror = function() {
          _this.webSocketState = 0;
        };
        // 监听socket关闭
        socket.onclose = function() {
          _this.webSocketState = 0;
        };
      }
    },
    //人员认证
    authPerson() {
      var _this = this;
      $.ajax({
        type: "get",
        url: "http://127.0.0.1:8080/api/ReadMsg",
        async: false, //这里没有用promise，须设置为同步，
        dataType: "json",
        success: function(data) {
          if (data.retmsg.indexOf("失败") > -1) {
            //监听身份证时调用
            return;
          } else {
            window.localStorage.cardInfo = JSON.stringify(data);
            var rid = window.localStorage.rid;
            _this.$refs.selApp.oper(data.name, data.cardno, rid);
          }
        },
        error: function() {
          clearInterval(_this.timer);
          _this.$message.error("设备异常，请检查是否成功安装驱动和接入设备！");
        }
      });
    },
    //测试
    clientWebSocketPost() {
      //公司id_门卫id_类型（1预约）_主键id
      var par =
        this.user.companyId +
        "_" +
        this.user.door.id +
        "_" +
        1 +
        "_" +
        "1274249964779737088";
      var param = { params: { criteria: par } };
      var _this = this;
      ws(param).then(res => {
        //alert(1);
        // if (publish_.isEmt(res)) {
        //   return;
        // }
      });
    },
    checkApp(rid, uid) {
      this.$refs.cardApp.oper(rid, uid);
    },
    selApp(rid, uid) {
      this.$refs.cardApp.oper(rid, uid);
    },
    cardApp(rid) {
      window.localStorage.rid = rid;
      this.$refs.checkApp.oper(rid);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/fksys/listen.vue